/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
import { RelType } from './LinkUtils.js';
export var AssignmentStatus;
(function (AssignmentStatus) {
    AssignmentStatus["DRAFT"] = "DRAFT";
    AssignmentStatus["ASSIGNED"] = "ASSIGNED";
})(AssignmentStatus || (AssignmentStatus = {}));
export var AssignmentSubmissionOwnershipEnums;
(function (AssignmentSubmissionOwnershipEnums) {
    AssignmentSubmissionOwnershipEnums["ANY"] = "ANY";
    AssignmentSubmissionOwnershipEnums["NONE"] = "NONE";
    AssignmentSubmissionOwnershipEnums["SELF"] = "SELF";
})(AssignmentSubmissionOwnershipEnums || (AssignmentSubmissionOwnershipEnums = {}));
export var AssignmentTaskIDEnums;
(function (AssignmentTaskIDEnums) {
    AssignmentTaskIDEnums["albumCover"] = "album-cover";
    AssignmentTaskIDEnums["animatedCharacter"] = "animated-character";
    AssignmentTaskIDEnums["bannerPrint"] = "banner-print";
    AssignmentTaskIDEnums["bannerWeb"] = "banner-web";
    AssignmentTaskIDEnums["blogGraphic"] = "blog-graphic";
    AssignmentTaskIDEnums["blogHeader"] = "blog-header";
    AssignmentTaskIDEnums["bookCover"] = "book-cover";
    AssignmentTaskIDEnums["bookmark"] = "bookmark";
    AssignmentTaskIDEnums["brochure"] = "brochure";
    AssignmentTaskIDEnums["businessCard"] = "business-card";
    AssignmentTaskIDEnums["calendar"] = "calendar";
    AssignmentTaskIDEnums["cardGreeting"] = "card-greeting";
    AssignmentTaskIDEnums["certificate"] = "certificate";
    AssignmentTaskIDEnums["checklist"] = "checklist";
    AssignmentTaskIDEnums["classSchedule"] = "class-schedule";
    AssignmentTaskIDEnums["comicStrip"] = "comic-strip";
    AssignmentTaskIDEnums["conceptMap"] = "concept-map";
    AssignmentTaskIDEnums["couponSheet"] = "coupon-sheet";
    AssignmentTaskIDEnums["coverPage"] = "cover-page";
    AssignmentTaskIDEnums["deviceCameraRecording"] = "device-camera-recording";
    AssignmentTaskIDEnums["displayAd"] = "display-ad";
    AssignmentTaskIDEnums["dividerPage"] = "divider-page";
    AssignmentTaskIDEnums["drawing"] = "drawing";
    AssignmentTaskIDEnums["drawingWorksheet"] = "drawing-worksheet";
    AssignmentTaskIDEnums["ebookCover"] = "ebook-cover";
    AssignmentTaskIDEnums["emailHeader"] = "email-header";
    AssignmentTaskIDEnums["etsyShopBanner"] = "etsy-shop-banner";
    AssignmentTaskIDEnums["etsyShopCover"] = "etsy-shop-cover";
    AssignmentTaskIDEnums["eventbriteHeader"] = "eventbrite-header";
    AssignmentTaskIDEnums["facebookAd"] = "facebook-ad";
    AssignmentTaskIDEnums["facebookEventCover"] = "facebook-event-cover";
    AssignmentTaskIDEnums["facebookGroupCover"] = "facebook-group-cover";
    AssignmentTaskIDEnums["facebookPageCover"] = "facebook-page-cover";
    AssignmentTaskIDEnums["facebookPost"] = "facebook-post";
    AssignmentTaskIDEnums["facebookProfileCover"] = "facebook-profile-cover";
    AssignmentTaskIDEnums["facebookShopCover"] = "facebook-shop-cover";
    AssignmentTaskIDEnums["facebookStory"] = "facebook-story";
    AssignmentTaskIDEnums["flashCard"] = "flash-card";
    AssignmentTaskIDEnums["flashCardSheet"] = "flash-card-sheet";
    AssignmentTaskIDEnums["flyer"] = "flyer";
    AssignmentTaskIDEnums["generatedImage"] = "generated-image";
    AssignmentTaskIDEnums["giftCertificate"] = "gift-certificate";
    AssignmentTaskIDEnums["giftTag"] = "gift-tag";
    AssignmentTaskIDEnums["googleClassroomBanner"] = "google-classroom-banner";
    AssignmentTaskIDEnums["graph"] = "graph";
    AssignmentTaskIDEnums["graphicOrganizer"] = "graphic-organizer";
    AssignmentTaskIDEnums["idCard"] = "id-card";
    AssignmentTaskIDEnums["infographic"] = "infographic";
    AssignmentTaskIDEnums["instagramAd"] = "instagram-ad";
    AssignmentTaskIDEnums["instagramCarousel"] = "instagram-carousel";
    AssignmentTaskIDEnums["instagramLandscapePost"] = "instagram-landscape-post";
    AssignmentTaskIDEnums["instagramPortraitPost"] = "instagram-portrait-post";
    AssignmentTaskIDEnums["instagramReel"] = "instagram-reel";
    AssignmentTaskIDEnums["instagramSquarePost"] = "instagram-square-post";
    AssignmentTaskIDEnums["instagramStory"] = "instagram-story";
    AssignmentTaskIDEnums["instagramStoryAd"] = "instagram-story-ad";
    AssignmentTaskIDEnums["invitation"] = "invitation";
    AssignmentTaskIDEnums["invoice"] = "invoice";
    AssignmentTaskIDEnums["journal"] = "journal";
    AssignmentTaskIDEnums["label"] = "label";
    AssignmentTaskIDEnums["labelSheet"] = "label-sheet";
    AssignmentTaskIDEnums["leafletTrifold"] = "leaflet-trifold";
    AssignmentTaskIDEnums["lessonPlan"] = "lesson-plan";
    AssignmentTaskIDEnums["letter"] = "letter";
    AssignmentTaskIDEnums["letterhead"] = "letterhead";
    AssignmentTaskIDEnums["lineAdSmall"] = "line-ad-small";
    AssignmentTaskIDEnums["lineAdSquare"] = "line-ad-square";
    AssignmentTaskIDEnums["lineAdSquareVideo"] = "line-ad-square-video";
    AssignmentTaskIDEnums["lineAdVertical"] = "line-ad-vertical";
    AssignmentTaskIDEnums["lineRichMenuLarge"] = "line-rich-menu-large";
    AssignmentTaskIDEnums["lineRichMenuSmall"] = "line-rich-menu-small";
    AssignmentTaskIDEnums["lineRichMessage"] = "line-rich-message";
    AssignmentTaskIDEnums["linkedinBlogPost"] = "linkedin-blog-post";
    AssignmentTaskIDEnums["linkedinPost"] = "linkedin-post";
    AssignmentTaskIDEnums["linkedinProfileCover"] = "linkedin-profile-cover";
    AssignmentTaskIDEnums["logo"] = "logo";
    AssignmentTaskIDEnums["magazine"] = "magazine";
    AssignmentTaskIDEnums["mediaKit"] = "media-kit";
    AssignmentTaskIDEnums["meme"] = "meme";
    AssignmentTaskIDEnums["memo"] = "memo";
    AssignmentTaskIDEnums["menu"] = "menu";
    AssignmentTaskIDEnums["mindmap"] = "mindmap";
    AssignmentTaskIDEnums["mobileVideo"] = "mobile-video";
    AssignmentTaskIDEnums["mug"] = "mug";
    AssignmentTaskIDEnums["nameTag"] = "name-tag";
    AssignmentTaskIDEnums["newsletter"] = "newsletter";
    AssignmentTaskIDEnums["noteHeaderImage"] = "note-header-image";
    AssignmentTaskIDEnums["onlineNewsletter"] = "online-newsletter";
    AssignmentTaskIDEnums["onlineReport"] = "online-report";
    AssignmentTaskIDEnums["pamphlet"] = "pamphlet";
    AssignmentTaskIDEnums["photoBook"] = "photo-book";
    AssignmentTaskIDEnums["pinterestIdeaPin"] = "pinterest-idea-pin";
    AssignmentTaskIDEnums["pinterestPost"] = "pinterest-post";
    AssignmentTaskIDEnums["pinterestSquare"] = "pinterest-square";
    AssignmentTaskIDEnums["pinterestVertical"] = "pinterest-vertical";
    AssignmentTaskIDEnums["placeCard"] = "place-card";
    AssignmentTaskIDEnums["planner"] = "planner";
    AssignmentTaskIDEnums["playlistCover"] = "playlist-cover";
    AssignmentTaskIDEnums["podcastCover"] = "podcast-cover";
    AssignmentTaskIDEnums["postcard"] = "postcard";
    AssignmentTaskIDEnums["poster"] = "poster";
    AssignmentTaskIDEnums["presentation"] = "presentation";
    AssignmentTaskIDEnums["printAd"] = "print-ad";
    AssignmentTaskIDEnums["program"] = "program";
    AssignmentTaskIDEnums["proposal"] = "proposal";
    AssignmentTaskIDEnums["recipeCard"] = "recipe-card";
    AssignmentTaskIDEnums["redditCover"] = "reddit-cover";
    AssignmentTaskIDEnums["report"] = "report";
    AssignmentTaskIDEnums["reportCard"] = "report-card";
    AssignmentTaskIDEnums["resume"] = "resume";
    AssignmentTaskIDEnums["rubric"] = "rubric";
    AssignmentTaskIDEnums["snapchatAd"] = "snapchat-ad";
    AssignmentTaskIDEnums["snapchatFilter"] = "snapchat-filter";
    AssignmentTaskIDEnums["soundcloudBanner"] = "soundcloud-banner";
    AssignmentTaskIDEnums["tableOfContents"] = "table-of-contents";
    AssignmentTaskIDEnums["ticket"] = "ticket";
    AssignmentTaskIDEnums["tiktokAd"] = "tiktok-ad";
    AssignmentTaskIDEnums["tiktokVideo"] = "tiktok-video";
    AssignmentTaskIDEnums["tshirt"] = "tshirt";
    AssignmentTaskIDEnums["tumblrBanner"] = "tumblr-banner";
    AssignmentTaskIDEnums["twitchBanner"] = "twitch-banner";
    AssignmentTaskIDEnums["twitchOverlay"] = "twitch-overlay";
    AssignmentTaskIDEnums["twitterHeader"] = "twitter-header";
    AssignmentTaskIDEnums["twitterPost"] = "twitter-post";
    AssignmentTaskIDEnums["twitterVideo"] = "twitter-video";
    AssignmentTaskIDEnums["video"] = "video";
    AssignmentTaskIDEnums["wallpaperDesktop"] = "wallpaper-desktop";
    AssignmentTaskIDEnums["wallpaperMobile"] = "wallpaper-mobile";
    AssignmentTaskIDEnums["webpage"] = "webpage";
    AssignmentTaskIDEnums["webpageJournal"] = "webpage-journal";
    AssignmentTaskIDEnums["worksheet"] = "worksheet";
    AssignmentTaskIDEnums["youtubeBanner"] = "youtube-banner";
    AssignmentTaskIDEnums["youtubeDisplayAds"] = "youtube-display-ads";
    AssignmentTaskIDEnums["youtubeProfilePhoto"] = "youtube-profile-photo";
    AssignmentTaskIDEnums["youtubeShorts"] = "youtube-shorts";
    AssignmentTaskIDEnums["youtubeThumbnail"] = "youtube-thumbnail";
    AssignmentTaskIDEnums["youtubeVideo"] = "youtube-video";
    AssignmentTaskIDEnums["youtubeVideoAd"] = "youtube-video-ad";
    AssignmentTaskIDEnums["zoomBackground"] = "zoom-background";
})(AssignmentTaskIDEnums || (AssignmentTaskIDEnums = {}));
